import DownloadApp from "../components/DownloadApp";
import CallToActionHospitalitySection from "../components/PageSections/UseCases/CallToActionHospitalitySection";
import UseCaseHospitalitySection from "../components/PageSections/UseCases/UseCaseHospitalitySection";
import CustomerLogosSection from "../components/PageSections/UseCases/CustomerLogosSection";
import HospitalityUsagePicturesSection from "../components/PageSections/UseCases/HospitalityUsagePicturesSection";
import GrowthSection from "../components/PageSections/KatalifeFree/GrowthSection";


const UseCaseHospitalityPage = () => {
    return (
        <main>
            <UseCaseHospitalitySection />
            <CustomerLogosSection />
            <CallToActionHospitalitySection />
            <HospitalityUsagePicturesSection />
            <GrowthSection />
            <DownloadApp />
        </main>
    );
};

export default UseCaseHospitalityPage;
